import { createFileRoute } from "@tanstack/react-router";
import { AdminUserAiPage } from "@/features/admin/org-ai";

/** ALP-86: user → AI activity across the user's orgs. */
export const Route = createFileRoute("/admin/users_/$userId/ai")({
  head: () => ({ meta: [{ title: "AI activity · User · Admin · Malfak" }] }),
  component: UserAiRoute,
});

function UserAiRoute() {
  const { userId } = Route.useParams();
  return <AdminUserAiPage key={userId} userId={userId} />;
}
